export enum BenefitEndpoints {
    GetDiscounts = "ux-consulta-beneficios-cliente-pga/mep/servicio-al-cliente/v1/discounts",
    GetEstablishments = "ux-consulta-beneficios-cliente-pga/mep/servicio-al-cliente/v1/discounts/:discountId/premises",
}
